/* eslint-disable import/no-cycle */
// import Vue from 'vue';
import moment from 'moment';
import Api from '@/api';

// eslint-disable-next-line no-unused-vars
const ALL_SYSTEMS = {
    SAP: 'sap',
    C1: 'celeraone',
    EVALANCHE: 'evalanche',
    SALESFORCE: 'salesforce',
};

const theState = {
    loading: true,
    isChecking: false,
    ssoId: '',
    title: '',
    firstname: '',
    lastname: '',
    gender: '',
    street: '',
    streetNumber: '',
    zipCode: '',
    city: '',
    storeId: '',
    systems: [],
    wizardStep: 1,
    birthdate: moment().format('DD.MM.YYYY'),
    valid: false,
    inAction: false,
};

const actions = {
    initState({ commit }, ssoId) {
        commit('setSsoId', ssoId);
        commit('setLoading', true);
        if (ssoId) {
            Api.customer.getMasterdata(ssoId)
                .then((result) => {
                    if (result.data) {
                        commit('setFirstname', result.data.first_name);
                        commit('setLastname', result.data.last_name);
                        commit('setStreet', result.data.street ? result.data.street : '');
                        commit('setStreetnumber', result.data.housenumber ? result.data.housenumber : '');
                        commit('setZipCode', result.data.postcode ? result.data.postcode : '');
                        commit('setCity', result.data.city ? result.data.city : '');
                        commit('setGender', result.data.gender);
                        commit('setBirthdate', moment(result.data.birth_date).format('DD.MM.YYYY'));
                    }
                })
                .catch(() => {
                    commit('snackbar/error', 'Beim Laden der Kundendaten ist ein Fehler aufgetreten.', { root: true });
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        }
    },
    checkCustomer({ commit }, ssoId) {
        commit('setCheck', true);
        if (ssoId) {
            Api.customer.getCheckMasterdata(ssoId)
                .then((result) => {
                    const systems = result.data.data.map(item => ({
                        selected: true,
                        id: item.id ? item.id : '',
                        system: item.system,
                        scope: item.scope,
                        // eslint-disable-next-line no-nested-ternary
                        gender: item.gender === 'male' ? 'Herr' : item.gender === 'female' ? 'Frau' : item.gender === 'company' ? 'Firma' : '',
                        firstName: item.firstName,
                        lastName: item.lastName,
                        street: item.street ? item.street : '',
                        streetNumber: item.housenumber ? item.housenumber : '',
                        zipCode: item.postcode ? item.postcode : '',
                        city: item.city ? item.city : '',
                        birthdate: item.birthdate ? moment(item.birthdate).format('DD.MM.YYYY') : '',
                    }));
                    commit('setSystems', systems);
                    commit('setWizardStep', 2);
                })
                .catch(() => {
                    commit('setWizardStep', 1);
                    commit('snackbar/error', 'Beim Überprüfen der Kundendaten ist ein Fehler aufgetreten.', { root: true });
                })
                .finally(() => {
                    commit('setCheck', false);
                });
        }
    },
    updateCustomer({ commit, state }, ssoId) {
        commit('setSsoId', ssoId);
        commit('setLoading', true);
        const masterdata = {
            gender: state.gender,
            title: state.title,
            firstName: state.firstname,
            lastName: state.lastname,
            street: state.street,
            housenumber: state.streetNumber,
            postcode: state.zipCode,
            city: state.city,
            birthdate: moment(state.birthdate, 'DD.MM.YYYY').format('YYYY-MM-DD'),
        };
        let systems = {};

        state.systems.filter(s => s.selected).forEach((item) => {
            if (item.system.toLowerCase() === ALL_SYSTEMS.C1) {
                systems = {
                    ...systems,
                    celeraone: {
                        update: true,
                    },
                };
            } else if (item.system.toLowerCase() === ALL_SYSTEMS.EVALANCHE) {
                systems = {
                    ...systems,
                    evalanche: {
                        update: true,
                        storeId: item.id === '' ? state.storeId : '',
                    },
                };
            } else if (item.system.toLowerCase() === ALL_SYSTEMS.SALESFORCE) {
                systems = {
                    ...systems,
                    salesforce: {
                        update: true,
                    },
                };
            } else if (item.system.toLowerCase() === ALL_SYSTEMS.SAP) {
                if (systems.sap) {
                    systems.sap.customerIds.push(
                        {
                            id: item.id,
                            scope: item.scope,
                        },
                    );
                } else {
                    systems = {
                        ...systems,
                        sap: {
                            customerIds: [
                                {
                                    id: item.id,
                                    scope: item.scope,
                                },
                            ],
                        },
                    };
                }
            }
        });

        return new Promise((resolve, reject) => {
            if (ssoId) {
                Api.customer.updateMasterdata(ssoId, masterdata, systems)
                    .then(() => {
                        commit('snackbar/success', 'Die Stammdaten wurden erfolgreich gespeichert.', { root: true });
                        resolve();
                    })
                    .catch(() => {
                        commit('snackbar/error', 'Beim Speichern der Stammdaten ist ein Fehler aufgetreten.', { root: true });
                        reject();
                    })
                    .finally(() => {
                        commit('setLoading', false);
                        commit('setWizardStep', 1);
                    });
            } else {
                reject();
            }
        });
    },

    resetState({ commit }) {
        commit('setLoading', true);
        commit('setCheck', false);
        commit('setSsoId', '');
        commit('setGender', '');
        commit('setTitle', '');
        commit('setFirstname', '');
        commit('setLastname', '');
        commit('setStreet', '');
        commit('setStreetnumber', '');
        commit('setZipCode', '');
        commit('setCity', '');
        commit('setBirthdate', moment().format('DD.MM.YYYY'));
        commit('setValid', false);
        commit('setInAction', false);
        commit('setSystems', []);
        commit('setWizardStep', 1);
        commit('setStoreId', '');
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },

    setCheck(state, check) {
        state.isChecking = check;
    },

    setSsoId(state, ssoId) {
        state.ssoId = ssoId;
    },

    setGender(state, gender) {
        state.gender = gender;
    },

    setTitle(state, title) {
        state.title = title;
    },

    setBirthdate(state, date) {
        state.birthdate = date;
    },

    setSystems(state, systems) {
        state.systems = systems;
    },

    setFirstname(state, firstname) {
        state.firstname = firstname;
    },

    setLastname(state, lastname) {
        state.lastname = lastname;
    },

    setStreet(state, street) {
        state.street = street;
    },

    setWizardStep(state, step) {
        state.wizardStep = step;
    },

    setStreetnumber(state, streetnumber) {
        state.streetNumber = streetnumber;
    },

    setZipCode(state, zipCode) {
        state.zipCode = zipCode;
    },

    setCity(state, city) {
        state.city = city;
    },

    setValid(state, valid) {
        state.valid = valid;
    },

    setInAction(state, inAction) {
        state.inAction = inAction;
    },

    setStoreId(state, storeId) {
        state.storeId = storeId;
    },
};

export default {
    namespaced: true,
    state: theState,
    actions,
    mutations,
};
